import React from 'react';
import './About.css';

const About = () => (
  <div className="about">
    <section>
      <h2> Was ist PetPate ? </h2>
      <p>PetPate ist eine Tierbetreuunugs - Gemeinschaft, Mitglieder hüten Tiere von anderen Nutzern.
                Menschen die kein eigenes Tier(mehr)
                haben können, bekommen so die Möglichkeit sich trotzdem um eines zu kümmern und Tierbesitzer können so ihre
                Lieblinge kostengünstig, spontan und an jedem Tag im Jahr bei fürsorglichen, privaten Tierfreunden unterbringen.
      </p>
    </section>
    <section>
      <h2>Wer nutzt PetPate?</h2>
      <ul>
        <li>Die, denen das Tierheim/Sitter zu teuer ist </li>
        <li>Solche die ihren Liebling auch an WE + Feiertagen bringen und holen möchten</li>
        <li>Familien, Jugendliche, Arbeitstätige und ältere</li>
        <li>Tierfreunde die kein eigenes Tier (mehr) haben können oder wollen aber trotzdem sich ab und zu um eines kümmern möchten</li>
        <li>Neu Zugezogene oder solche die niemanden kennen der das Tier betreut</li>
        <li>Menschen die erwägen ein bestimmtes Tier oder Rasse zu kaufen und es vorher auf Probe kennenlernen möchten</li>
        <li>Tierliebhaber die sich auch mit Gleichgesinnten aus der weiteren Umgebung austauschen wollen</li>
      </ul>
    </section>
    <section>
      <h2>Vorteile deiner Mitgliedschaft für Besitzer</h2>
      <ul>
        <li>Mehr Freiheit für alle Tierbesitzer</li>
        <li>Super günstig im Verhältnis zum Tierheim/Tiersitter</li>
        <li>Private, verantwortungsvolle Paten</li>
        <li>Tiere können an JEDEM Tag gebracht und geholt werden</li>
        <li>PetPfoten sammeln und Pate des Jahres werden</li>
        <li>10% auf Tierversicherungen nur für Mitglieder (?)</li>
      </ul>
    </section>
    <section>
      <h2>Vorteile deiner Mitgliedschaft für Paten:</h2>
      <ul>
        <li>Du hast keine Zeit für ein eigenes Tier.. Hier kannst Du wann immer Du willst ein Tier betreuen und wieder abgeben, ohne ein eigenes zu besitzen</li>
        <li>Du erwägst dir ein bestimmtes Tier oder eine Rasse anzuschaffen..
                        Hier wartet genau Dieses auf dich, so kannst Du es vor einem Kauf auf Probe betreuen und kennenlernen
        </li>
        <li>Du hast ein Alter erreicht, wo Du kein eigenes Tier mehr besitzen möchtest.. Bei PetPate hast Du die Möglichkeit dich gelegentlich um eines zu kümmern</li>
      </ul>
    </section>
  </div>
);

export default About;



// WEBPACK FOOTER //
// ./src/pages/About/index.js